import React from 'react';
import ProductListingPage from '../components/ProductListingPage';
import { useNavigate } from 'react-router-dom';
import teaProducts from '../data/teaProducts';

const TeaProductsPage = () => {
  const navigate = useNavigate();

  return (
    <ProductListingPage
      title="TEA"
      subtitle="PRODUCTS"
      products={teaProducts}
      categories={['All']}
      titleColor="#FFFFFF"
      backButtonPosition="right"
      contentTopPadding={{ xs: 1, md: 2 }}
      backButtonMarginBottom={1}
      headerInline
      onProductClick={(product) => navigate(`/products/tea/${product.id}`)}
    />
  );
};

export default TeaProductsPage;